export default __webpack_public_path__ + "static/media/a017-f.ae288386.svg";